import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import { computed, PropType } from 'vue';
import { VATableColumn, VATableRecord } from '../extends/typing';
import { formatRecordValue } from '../extends/hooks';

import TableRouter from './TableRouter';
import TableTag from './TableTag';
import TableA from './TableA';
import TableCopy from './TableCopy';


export default /*@__PURE__*/_defineComponent({
  __name: 'VATableItem',
  props: {
  column: {
    type: Object as PropType<VATableColumn>,
    required: true,
  },
  record: {
    type: Object as PropType<VATableRecord>,
    required: true,
  },
},
  setup(__props) {

const components = {
  router: TableRouter,
  tag: TableTag,
  a: TableA,
  copy: TableCopy,
};
const props = __props;

const value = computed(() => {
  return formatRecordValue(props.record, props.column as VATableColumn);
});

return (_ctx: any,_cache: any) => {
  return (__props.column.tagType in components)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[__props.column.tagType]), {
        key: 0,
        value: value.value,
        options: __props.column.options,
        record: __props.record
      }, null, 8, ["value", "options", "record"]))
    : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(value.value), 1))
}
}

})